<template>
  <div id="signature" ref="appRoot">
    <!--
      Signature Analysis
    -->
    <section class="analysis">
      <!--Title Area-->
      <div class="title-area gutter">
        <div class="left">
          <div class="icon">
            <i class="fas fa-drafting-compass"></i>
          </div>
          <div>
            <h2 class="title">{{ 'Kriminal Analiz'|trans }}</h2>
            <span class="description">{{ 'İmza analiz için PDF dosya yükleyin.'|trans }}</span>
          </div>
        </div>
        <div class="right title-actions">
          <button class="btn btn-light" @click="toggleFullScreen"><i class="fas" :class="isFullScreen ? 'fa-compress' : 'fa-expand'"></i><span>{{ 'Tam Ekran'|trans }}</span></button>
          <button class="ml-2 btn btn-light" @click="isFileBrowser = !isFileBrowser"><i class="fas" :class="isFileBrowser ? 'fa-arrow-from-left' : 'fa-arrow-from-right'"></i></button>
        </div>
      </div>

      <!--Action Area-->
      <div class="actions-area">
        <!--Dropdown Area-->
        <div class="item settins-dropdown">
          <button class="btn" :class="{'active': settingsDropdown}" @click="settingsDropdown = !settingsDropdown">
            <i class="far fa-cog"></i>
            <span class="text">{{ 'Seçenekler'|trans }}</span>
          </button>
          <div class="dropdown-area" v-show="settingsDropdown" @mouseleave="settingsDropdown = false">
            <div class="item">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="selectAll"
                  :disabled="selected.length < 1"
                  :checked="allChecked"
                  @click="checkAllSignature(!allChecked)"
                >
                <label class="custom-control-label" for="selectAll">{{ 'Tümünü Seç'|trans }}</label>
              </div>
            </div>
            <div class="item">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="viewAngle"
                  v-model="options.direction"
                  :disabled="selected.length < 1"
                >
                <label class="custom-control-label" for="viewAngle">{{ 'Hareket Yönü Göster'|trans }}</label>
              </div>
            </div>
            <div class="item">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="viewHover"
                  v-model="options.hover"
                  :disabled="selected.length < 1"
                >
                <label class="custom-control-label" for="viewHover">{{ 'Hover Göster'|trans }}</label>
              </div>
            </div>
            <div class="item">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="viewSignature"
                  v-model="options.viewSignature"
                  :disabled="selected.length < 1"
                >
                <label class="custom-control-label" for="viewSignature">{{ 'İmzayı Göster'|trans }}</label>
              </div>
            </div>
            <div class="item">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="viewPoint"
                  v-model="options.viewPoint"
                  :disabled="selected.length < 1"
                >
                <label class="custom-control-label" for="viewPoint">{{ 'Datayı Göster'|trans }}</label>
              </div>
            </div>
            <div class="item">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="fullWidth"
                  v-model="options.fullWidth"
                  :disabled="selected.length < 1 || options.seperate === false"
                >
                <label class="custom-control-label" for="fullWidth">{{ 'Tam Genişlik'|trans }}</label>
              </div>
            </div>
          </div>
        </div>

        <!--Multiple Player Actions-->
        <actions class="d-flex ml-auto" :multiple="true" v-if="!isComparePoints"></actions>

        <!--Right Aligned -->
        <div class="d-flex" v-if="!isComparePoints">
          <div class="item">
            <label for="stickySignature" class="btn mb-0 pointer">
              <div class="custom-control custom-switch">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="stickySignature"
                  v-model="options.sticky"
                  :disabled="selected.length < 1 || !options.seperate"
                >
                <label class="custom-control-label" for="stickySignature">{{ 'Yapışkan Görünüm'|trans }}</label>
              </div>
            </label>
          </div>
          <div class="item">
            <label for="seperateSignature" class="btn mb-0 pointer">
              <div class="custom-control custom-switch">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="seperateSignature"
                  v-model="options.seperate"
                  :disabled="selected.length < 1"
                >
                <label class="custom-control-label" for="seperateSignature">{{ 'İmzaları Ayır'|trans }}</label>
              </div>
            </label>
          </div>
          <div class="item">
            <button class="btn" :disabled="checked.length < 1" @click="downloadPNG">
              <i class="far fa-file-image"></i>
              <span class="text">{{ 'PNG'|trans }}</span>
            </button>
          </div>
          <div class="item">
            <button class="btn" :disabled="checked.length < 1" @click="downloadCSV">
              <i class="fas fa-file-csv"></i>
              <span class="text">{{ 'CSV'|trans }}</span>
            </button>
          </div>
        </div>

        <!--Two Point Compare-->
        <div class="d-flex ml-auto" v-if="isComparePoints">
          <div class="item">
            <button class="btn" @click="clearCompare(null)">
              <i class="fas fa-times"></i>
              <span class="text">{{ 'İptal'|trans }}</span>
            </button>
          </div>
          <div class="item">
            <button class="btn" @click="comparePoints">
              <i class="fas fa-crop"></i>
              <span class="text">{{ 'Karşılaştır'|trans }}</span>
            </button>
          </div>
        </div>
      </div>

      <!--Analysis Area-->
      <div class="analysis-area">
        <div class="wrap" v-show="selected.length > 0">
          <!--Signature-->
          <signature
            ref="signature"
            :selected="selected"
            :options="options"
            :checked="checked"
            :selectedPoints="selectedPoints"
            :svgAutoSize="svgAutoSize"
            @checked-event="checkedEvent"
            :all-checked="allChecked"
            @all-checked-event="allCheckedEvent"
          ></signature>

          <!--Line Analysis-->
          <line-analysis
            :selected="selected" :options="options" :checked="checked"
          ></line-analysis>
        </div>

        <!--Empty-->
        <div class="wrap empty-content" v-if="selected.length === 0">
          <p>{{ 'Henüz imza seçmediniz.'|trans }}</p>
          <p>{{ "Karşılaştırma yapmak istediğiniz imzaları seçin ve 'KARŞILAŞTIR' butonuna tıklayın."|trans }}</p>
        </div>
      </div>
    </section>

    <!--
      File Browser | Upload and DeCrypt
    -->
    <file-browser
      :files="files" :selected="selected" :api="api" v-model="files" :svgAutoSize="svgAutoSize"
    ></file-browser>
  </div>
</template>

<script>
import FileBrowser from './FileBrowser';
import Signature from './Draw/Signature';
import LineAnalysis from './Draw/LineAnalysis';
import Actions from './Draw/Actions';
import svgToPNG from './Converter/svgToPNG';
import objectToCSV from './Converter/objectToCSV';

export default {
  components: {FileBrowser, Signature, LineAnalysis, Actions},
  props: ['api', 'blockchainApi', 'signatureVerify'],
  data() {
    return {
      files: [],
      selected: [],
      checked: [],
      selectedPoints: {},
      allChecked: false,
      options: {
        direction: false,
        hover: false,
        seperate: false,
        viewPoint: true,
        viewSignature: true,
        fullWidth: false,
        sticky: false
      },
      settingsDropdown: false,
      svgAutoSize: true,
      isFullScreen: false,
      isFileBrowser: true,
      colors: [
        [
          {color: 'hsl(257, 50%, 15%)'},
          {color: 'hsl(316, 100%, 20%)', disabled:true},
          {color: 'hsl(232, 100%, 28%)', disabled:true},
          {color: 'hsl(0, 100%, 37%)', disabled:true},
        ],
        [
          {color: 'hsl(316, 100%, 12%)'},
          {color: 'hsl(232, 100%, 20%)', disabled:true},
          {color: 'hsl(0, 100%, 28%)', disabled:true},
          {color: 'hsl(37, 100%, 37%)', disabled:true},
        ],
        [
          {color: 'hsl(232, 100%, 14%)'},
          {color: 'hsl(0, 100%, 20%)', disabled:true},
          {color: 'hsl(37, 100%, 28%)', disabled:true},
          {color: 'hsl(257, 50%, 40%)', disabled:true},
        ],
        [
          {color: 'hsl(0, 100%, 12%)'},
          {color: 'hsl(37, 100%, 20%)', disabled:true},
          {color: 'hsl(257, 50%, 30%)', disabled:true},
          {color: 'hsl(316, 100%, 37%)', disabled:true},
        ],
        [
          {color: 'hsl(37, 100%, 12%)'},
          {color: 'hsl(257, 50%, 22%)', disabled:true},
          {color: 'hsl(316, 100%, 28%)', disabled:true},
          {color: 'hsl(232, 100%, 37%)', disabled:true},
        ],
        [
          {color: 'hsl(232, 100%, 15%)'},
          {color: 'hsl(232, 100%, 16%)', disabled:true},
          {color: 'hsl(232, 100%, 16%)', disabled:true},
          {color: 'hsl(232, 100%, 16%)', disabled:true},
        ],
        [
          {color: 'hsl(37, 100%, 13%)'},
          {color: 'hsl(37, 100%, 14%)', disabled:true},
          {color: 'hsl(37, 100%, 14%)', disabled:true},
          {color: 'hsl(37, 100%, 14%)', disabled:true},
        ],
        [
          {color: 'hsl(0, 100%, 21%)'},
          {color: 'hsl(0, 100%, 22%)', disabled:true},
          {color: 'hsl(0, 100%, 22%)', disabled:true},
          {color: 'hsl(0, 100%, 22%)', disabled:true},
        ],
      ]
    }
  },
  watch: {
      'options.seperate': function (newVal, oldVal) {
        if (!newVal) {
          this.options.sticky = false
        }
      }
  },
  computed: {
    isComparePoints: function () {
      if (Object.keys(this.selectedPoints).length === 0) {
        return false;
      }

      for (const [key, value] of Object.entries(this.selectedPoints)) {
        if (value.length !== 2) {
          return false;
        }
      }

      return true;
    },
  },
  methods: {
    /**
     * Download Checked to PNG File
     */
    downloadPNG() {
      if (this.options.seperate) {
        return this.checked.forEach((signature, index) => {
          let svg = this.$refs.signature.$refs[signature.id];
          if (svg) {
            let fileName = signature.document + '-' + index + '.png';
            svgToPNG(svg[0], fileName);
          }
        })
      }

      let svg = this.$refs.signature.$refs.svg0;
      if (svg) {
        let fileName = 'all-signature.png';
        svgToPNG(svg, fileName);
      }
    },

    /**
     * Download Checked to CSV File
     */
    downloadCSV() {
      return this.checked.forEach((signature, index) => {
        this.selected.forEach((document) => {
          document.signatures.forEach((selectedSignature) => {
            if (selectedSignature.id === signature.id) {
              objectToCSV(selectedSignature.biometricData, document.name + '-' + index + '.csv');
            }
          });
        });
      })
    },

    /**
     * Update Checked Event
     * @param signature
     */
    checkedEvent({signature}) {
      if (!Array.isArray(signature)) {
        signature = [signature];
      } else {
        this.checked = [];
      }

      signature.forEach((signature) => {
        let index = this.checked.findIndex(sIndex => sIndex === signature)

        if (index === -1) {
          this.checked.push(signature)
        } else {
          this.checked = this.checked.filter((_, i) => i !== index)
        }
      })
    },

    /**
     * All Checked Event
     */
    allCheckedEvent(event) {
      this.allChecked = event;
    },

    /**
     * Check All Signature
     */
    checkAllSignature(event) {
      this.$refs.signature.checkAll(event);
    },

    /**
     * Compate Two Points
     */
    comparePoints() {
      // Disable SVG Auto Size
      this.svgAutoSize = false;

      // Filter Selected Points
      this.selected = this.selected.map((document) => {
        return {
          ...document,
          'signatures': document.signatures
            .filter((signature) => this.selectedPoints.hasOwnProperty(signature.id))
            .map((signature) => {
              return {
                ...signature,
                'biometricData': signature.biometricData
                  .filter((d, index) => (index >= this.selectedPoints[signature.id][0]['pIndex']) &&
                    (index <= this.selectedPoints[signature.id][1]['pIndex'])
                  )
              }
            })
        }
      })

      // Clear Compare Items
      this.clearCompare();
    },

    /**
     * Clear Selected Points
     */
    clearCompare(signatureId) {
      if (signatureId) {
        this.$delete(this.selectedPoints, signatureId)
      } else {
        this.$set(this, 'selectedPoints', {})
      }

      this.$refs.signature.$forceUpdate();
    },

    toggleFullScreen() {
      if (!document.fullscreenElement) {
        this.$refs.appRoot.requestFullscreen();
      } else if (document.exitFullscreen)  {
        document.exitFullscreen();
      }
    }
  },
  mounted() {
    document.addEventListener('fullscreenchange', event => {
      this.isFullScreen = document.fullscreenElement;
    });
  }
}
</script>

<style lang="scss">
$color-border: rgb(233, 233, 233);
$color-text: rgb(83, 93, 101);
$color-text-muted: rgb(166, 166, 166);
$color-text-muted-dark: rgb(124, 128, 131);
$gutter: 10px 15px;

#signature {
  background: #FFF;
  border-radius: 5px;
  margin-top: 20px;
  display: flex;
  box-shadow: 0 0 20px -5px rgba(0, 0, 0, 0.07);
  font-size: 15px;
  height: calc(100vh - 90px);
  overflow: hidden;
  position: relative;

  .gutter {
    padding: $gutter;
  }

  .pointer {
    cursor: pointer;
  }

  // Title Area
  .title-area {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 2px solid $color-border;

    .left, .right {
      display: flex;
      align-items: center;
    }

    .left .icon i {
      margin-right: 15px;
      font-size: 40px;
    }

    .title {
      color: $color-text;
      margin-bottom: 0;
      font-weight: 500;
      line-height: 1.8rem;
      font-size: 1.3rem;
    }

    .description {
      color: $color-text-muted;
    }

    i {
      font-size: 16px;
      vertical-align: middle;
    }

    .title-actions {
      .btn {
        display: flex;
        align-items: center;
        border-radius: 6px;
        min-height: 36px;

        & i + span {
          margin-left: .625rem;
        }
      }
    }
  }

  // Actions Area
  .actions-area {
    border-bottom: 2px solid $color-border;
    display: flex;
    align-items: center;
    color: $color-text-muted-dark;
    font-weight: 500;
    padding: 5px 7.5px;
    min-height: 44px;

    .item {
      margin-right: 5px;
      display: flex;
      align-items: center;

      &:last-child {
        margin-right: 0;
      }
    }

    .btn {
      display: flex;
      align-items: center;
      color: $color-text-muted-dark;
      font-weight: 500;
      padding: 5px 7.5px;
      border-radius: 3px;

      i {
        font-size: 20px;
        color: $color-text;
      }

      .text {
        margin-left: .5rem;
      }
    }

    .custom-control-label {
      line-height: 20px;
    }
  }

  .settins-dropdown {
    position: relative;

    .dropdown-area {
      position: absolute;
      width: 210px;
      background: rgb(236 236 236);
      padding: 10px;
      box-shadow: 2px 2px 3px -1px rgba(0, 0, 0, 0.3);
      top: calc(100% + 1px);
      z-index: 2;
      border-radius: 2px;
      left: 1px;

      .item {
        margin-bottom: 5px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  // Empty Content
  .empty-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #999;
    text-align: center;
  }

  // Analysis
  .analysis {
    flex: 2.75;
    border-right: 2px solid $color-border;
    display: flex;
    flex-direction: column;
    margin-right: 25px;

    .analysis-area {
      overflow-y: scroll;
      height: 100%;
      max-height: 100%;

      .wrap {
        height: 100%;
        max-height: 100%;
        display: flex;
        flex-direction: column;
      }
    }
  }
}
</style>
